import React from 'react'
import { adminNavItems as dashboardItems } from '../components/sidebar/adminDashboardItems'
import { DashboardBase } from './DashboardBase'
import useAuth from '../hooks/useAuth'

const Dashboard = ({ children }: { children?: React.JSX.Element }) => {
    const { user } = useAuth()

    if (!user?.groups?.includes('superadmin')) return 'Du har inte behörighet till den här sidan.'

    return <DashboardBase dashboardItems={dashboardItems}>{children}</DashboardBase>
}

export default Dashboard
